module.exports = __webpack_public_path__ + "img/img4.0addf915.svg";